import { Component, NgZone, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { PlansService } from 'src/app/services/plans.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { Router } from "@angular/router";
import { VendorService } from 'src/app/services/vendor.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { VendorLoginDialogComponent } from 'src/app/vendor/vendor-login-dialog/vendor-login-dialog.component';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { TemplateRef, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Product } from 'src/app/shared/classes/product';
import { ProductService } from 'src/app/shared/services/product.service';
import { OrderService } from 'src/app/shared/services/order.service';
import { environment } from 'src/environments/environment';
import { InvoicesignalService } from 'src/app/shared/services/invoicesignal.service';

@Component({
  selector: 'app-plan-detail-page',
  templateUrl: './plan-detail-page.component.html',
  styleUrls: ['./plan-detail-page.component.scss'],
  providers: [WindowRefService]
})
export class PlanDetailPageComponent implements OnInit {
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  currentDate: string;
  rowDetails: any = {}; // Variable to hold plan details
  vendorData: any;
  paymentData: any;
  gstTotal: number = 0;
  totalPlanPrice: number = 0;
  discountedAmount: number = 0;
  isLoggedIn: boolean = false;
  vendorId: any;
  companyObject: any = {};
  paymentFailedStatus: boolean = false;
  paymentFailedMsg: any = "";
  orderId = '';




  private unsubscribe$ = new Subject<void>();
  gstTotalLabel:any;

  constructor(
    private adminService: AdminService,
    private plansService: PlansService,
    private paymentService: PaymentService,
    private winRef: WindowRefService,
    private router: Router,
    private vendorService: VendorService,
    private dialog: MatDialog,
    private authService: AuthService,
    private utilsDataService: UtilsDataService,
    private zone: NgZone,
 public productService: ProductService,
    private orderService: OrderService,
     private invoiceSignalService: InvoicesignalService



  ) {
    this.vendorService.vendorIdSubject$.subscribe(obj => {
      this.vendorData = obj;
      console.log("ggggg", obj);

    });
    this.paymentService.razorPay$.subscribe(obj => {
      this.paymentData = obj;
      console.log("hhhhh", obj);
    });
    // this.paymentService.paymentFailedActionData.subscribe(obj => {
    //   this.paymentFailedStatus=obj.paymentFailedStatus;
    //   this.paymentFailedMsg=obj.paymentFailedMsg;
    // });
    // this.companyObject = this.paymentService.companyDetails;
    this.isLoggedIn = this.authService.isLoggedIn();
    console.log("bghjkl", this.isLoggedIn, this.companyObject)
    // this.getCompanyDetailsByVendorId()

  }



  ngOnInit(): void {

    this.currentDate = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    this.rowDetails = this.plansService.selectedPlan;
    console.log("Selected Plan Details:", this.rowDetails);
    // this.calculateTotalPlanPrice();
    if (this.isLoggedIn === true && this.rowDetails.module_name === 'JOBS' || this.rowDetails.module_name === 'JOBS_DB') {
      console.log("bvvnm", this.isLoggedIn, this.rowDetails.module_name)
      this.getCompanyDetailsByVendorId()
    }


  }

  calculateTotalPlanPrice() {
    const planPrice = parseInt(this.rowDetails.plan_price) || 0;
    const discountType = this.rowDetails.discount_type;
    const discountValue = parseInt(this.rowDetails.offer_discount_percentage) || 0;
    const sgstValue = parseFloat(this.rowDetails.sgst) || 0;
    const cgstValue = parseFloat(this.rowDetails.cgst) || 0;
    const igstValue = parseFloat(this.rowDetails.igst) || 0;
    const cessValue = parseFloat(this.rowDetails.cess) || 0;

    this.gstTotal = sgstValue + cgstValue + igstValue + cessValue;

    let discount = 0;
    if (discountType === 'P') {
      discount = (planPrice * discountValue) / 100;
    } else if (discountType === 'F') {
      discount = discountValue;
    }

    this.discountedAmount = discount;

    const remainingPrice = planPrice - discount;
    const gstAmount = remainingPrice * (this.gstTotal / 100);
    this.totalPlanPrice = remainingPrice + gstAmount;

    this.isLoggedIn = this.authService.isLoggedIn();
    this.totalPlanPrice = parseFloat(this.totalPlanPrice.toFixed(2));
  }
  openLoginDialog() {
    const dialogRef = this.dialog.open(VendorLoginDialogComponent, {
      width: '45rem'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoggedIn = this.authService.isLoggedIn();
        if (this.isLoggedIn) {
          this.vendorId = result;
          console.log("jjj", result)
          this.getCompanyDetailsByVendorId()


        }
      }
    });
  }
  getCompanyDetailsByVendorId() {
    let reqObj = {
      // "uuid": this.vendorData.uuid
    };

    this.vendorService.getCompanyDetailsByVendorId(reqObj).subscribe((response: any) => {
      console.log("API Response:", response);

      if (response.statusCode === 200) {
        if (response.data != null) {
          this.paymentService.companyDetails = response.data;
          this.companyObject = this.paymentService.companyDetails;
        }

        if (this.isCompanyObjectEmpty() || this.isCityDetailsNull()) {
          const dialogRef = this.dialog.open(this.confirmationDialog);

          dialogRef.afterClosed().subscribe(result => {
            console.log("Dialog closed with result:", result);

            if (result) {
              this.router.navigate(["vendor/vendor-company-profile"]);
            } else {

            }
          });
        } else {
          // this.initiateOrder();
        }
      } else {
        console.error("API Response status code was not 200:", response.statusCode);
      }
    });
  }

  isCompanyObjectEmpty(): boolean {
    return !this.companyObject || Object.keys(this.companyObject).length === 0;
  }

  isCityDetailsNull(): boolean {
    return !this.companyObject?.city_details;
  }




  initiateOrder() {
    this.paymentFailedStatus = false;
    // this.getCompanyDetailsByVendorId()

    // this.paymentService.setPaymentFailed({paymentFailedStatus:false, paymentFailedMsg:""});
    // @joshi
    if (!this.isLoggedIn) {
      this.openLoginDialog();
      return;
    }


    let reqObj = {
      "amount": parseFloat(this.rowDetails.total_payble),
      "currency": "INR",
      "vendor_id": this.vendorData.id,
      "plan_id": this.rowDetails.id,
      "buyer_type": "VDR",
      "module_name": this.rowDetails.module_name
    }

    this.vendorService.initiateOrder(reqObj).pipe(
      takeUntil(this.unsubscribe$)  // The request will terminate if unsubscribe$ emits a value
    ).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        // this.paymentService.setrazorPaySubject(resp.data)
        this.payWithRazor(resp.data.order_id, "rzp_live_mX3w8t1Xhx5fa1");
        this.orderId = resp.data.order_id;
        console.log("mmmmmm ", resp.data.order_id);
      }
    });
  }

  payWithRazor(val: any, key: any) {

    let amount = (parseInt(this.rowDetails.plan_price) * 100);
    const options: any = {
      key: key,
      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: this.rowDetails.packageName, // company name or product name
      description: this.rowDetails.plan_description,  // product description
      image: 'assets/images/logos/final-logo.png', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#BF0000'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;

      console.log("response RAZORPAY::", response);
      console.log("RAZORPAY OPTIONS::", options);
      // pur_emp_type: CM/CN
      //pur_pac_type :JP/DB
      // packageData={packageName:"",amount:'',jobs:'',validity:'',description:''}
      // createPurchageOrder(){
      // let purchaseObj = {
      //   plan_id: this.rowDetails.id,
      //   vendor_id: this.vendorData.id,
      //   razorpay_order_id: response.razorpay_order_id
      // }
      let purchaseObj = {
        plan_id: this.rowDetails.id,
        vendor_id: this.vendorData.id,
        razorpay_order_id: options.order_id,
        razorpay_payment_id: response.razorpay_payment_id
      }

      this.paymentService.paymentDetails = { order_id: options.order_id, razorpay_payment_id: response.razorpay_payment_id }
      this.vendorService.createPurchaseOrder(purchaseObj).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          //           // this.errorStatus =true;
          //           // this.errorMsg = resp.supportMessage;
          //           // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"close","center","top",3);
          this.router.navigate(["pages/payment-success"])
        }
      })
      // }
      // console.log("purchaseObj:::",purchaseObj);
      // this.router.navigate(['payment-success'])
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled self.');
      // // alert("sssss");
      // // let paymentFailedStatus=true;
      // let paymentFailedMsg = `Don't worry, transaction failed. If you are amount debited, please connect with administrator with your order Id:<strong> ${this.orderId}</strong>`;
      // // console.log("===STS==",this.paymentFailedStatus,this.paymentFailedMsg)
      // this.paymentService.setPaymentFailed({paymentFailedStatus:true, paymentFailedMsg:paymentFailedMsg});
      this.zone.run(() => {
        console.log('Transaction cancelled self.');
        this.paymentFailedStatus = true
        this.paymentFailedMsg = `OOOOPS!!! Your transaction failed. If your amount is debited from your account, please connect with  Customer Support with your order Id: <strong>${this.orderId}</strong>`;

        // this.paymentService.setPaymentFailed({ paymentFailedStatus: true, paymentFailedMsg: paymentFailedMsg });
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  initiateDbPlansOrder() {
    this.paymentFailedStatus = false;
    // this.getCompanyDetailsByVendorId()

    // this.paymentService.setPaymentFailed({paymentFailedStatus:false, paymentFailedMsg:""});
    // @joshi
    if (!this.isLoggedIn) {
      this.openLoginDialog();
      return;
    }


    let reqObj = {
      "amount": parseFloat(this.rowDetails.total_payble),
      "currency": "INR",
      "vendor_id": this.vendorData.id,
      "plan_id": this.rowDetails.id,
      "buyer_type": "VDR",
      "module_name": this.rowDetails.module_name
    }

    this.vendorService.initiateDbPlansOrder(reqObj).pipe(
      takeUntil(this.unsubscribe$)  // The request will terminate if unsubscribe$ emits a value
    ).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        // this.paymentService.setrazorPaySubject(resp.data)
        this.payWithRazorDbPurchases(resp.data.order_id, "rzp_live_mX3w8t1Xhx5fa1");
        this.orderId = resp.data.order_id;
        console.log("mmmmmm ", resp.data.order_id);
      }
    });
  }

  payWithRazorDbPurchases(val: any, key: any) {

    let amount = (parseInt(this.rowDetails.plan_price) * 100);
    const options: any = {
      key: key,
      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: this.rowDetails.packageName, // company name or product name
      description: this.rowDetails.plan_description,  // product description
      image: 'assets/images/logos/final-logo.png', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#BF0000'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;

      console.log("response RAZORPAY::", response);
      console.log("RAZORPAY OPTIONS::", options);
      // pur_emp_type: CM/CN
      //pur_pac_type :JP/DB
      // packageData={packageName:"",amount:'',jobs:'',validity:'',description:''}
      // createPurchageOrder(){
      let purchaseObj = {
        plan_id: this.rowDetails.id,
        vendor_id: this.vendorData.id,
        razorpay_order_id: response.razorpay_order_id
      }

      this.paymentService.paymentDetails = { order_id: response.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id }
      this.vendorService.createDbPurchageOrder(purchaseObj).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          //           // this.errorStatus =true;
          //           // this.errorMsg = resp.supportMessage;
          //           // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"close","center","top",3);
          this.router.navigate(["pages/payment-success"])
        }
      })
      // }
      // console.log("purchaseObj:::",purchaseObj);
      // this.router.navigate(['payment-success'])
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled self.');
      // // alert("sssss");
      // // let paymentFailedStatus=true;
      // let paymentFailedMsg = `Don't worry, transaction failed. If you are amount debited, please connect with administrator with your order Id:<strong> ${this.orderId}</strong>`;
      // // console.log("===STS==",this.paymentFailedStatus,this.paymentFailedMsg)
      // this.paymentService.setPaymentFailed({paymentFailedStatus:true, paymentFailedMsg:paymentFailedMsg});
      this.zone.run(() => {
        console.log('Transaction cancelled self.');
        this.paymentFailedStatus = true
        this.paymentFailedMsg = `OOOOPS!!! Your transaction failed. If your amount is debited from your account, please connect with  Customer Support with your order Id: <strong>${this.orderId}</strong>`;

        // this.paymentService.setPaymentFailed({ paymentFailedStatus: true, paymentFailedMsg: paymentFailedMsg });
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }


  initiateAdvertPlansOrder() {
    this.paymentFailedStatus = false;
    // this.getCompanyDetailsByVendorId()

    // this.paymentService.setPaymentFailed({paymentFailedStatus:false, paymentFailedMsg:""});
    // @joshi
    if (!this.isLoggedIn) {
      this.openLoginDialog();
      return;
    }


    let reqObj = {
      "amount": parseFloat(this.rowDetails.total_payble),
      "currency": "INR",
      "vendor_id": this.vendorData.id,
      "plan_id": this.rowDetails.id,
      "buyer_type": "VDR",
      "module_name": this.rowDetails.module_name
    }

    this.vendorService.initiateAdvertPlansOrder(reqObj).pipe(
      takeUntil(this.unsubscribe$)  // The request will terminate if unsubscribe$ emits a value
    ).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        // this.paymentService.setrazorPaySubject(resp.data)
        this.payWithRazorAdvertPurchases(resp.data.order_id, "rzp_live_mX3w8t1Xhx5fa1");
        this.orderId = resp.data.order_id;
        console.log("mmmmmm ", resp.data.order_id);
      }
    });
  }

  payWithRazorAdvertPurchases(val: any, key: any) {

    let amount = (parseInt(this.rowDetails.plan_price) * 100);
    const options: any = {
      key: key,
      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: this.rowDetails.packageName, // company name or product name
      description: this.rowDetails.plan_description,  // product description
      image: 'assets/images/logos/final-logo.png', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#BF0000'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;

      console.log("response RAZORPAY::", response);
      console.log("RAZORPAY OPTIONS::", options);
      // pur_emp_type: CM/CN
      //pur_pac_type :JP/DB
      // packageData={packageName:"",amount:'',jobs:'',validity:'',description:''}
      // createPurchageOrder(){
      let purchaseObj = {
        plan_id: this.rowDetails.id,
        vendor_id: this.vendorData.id,
        razorpay_order_id: response.razorpay_order_id
      }

      this.paymentService.paymentDetails = { order_id: response.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id }
      this.vendorService.createAdvertPurchageOrder(purchaseObj).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          //           // this.errorStatus =true;
          //           // this.errorMsg = resp.supportMessage;
          //           // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"close","center","top",3);
          this.router.navigate(["pages/payment-success"])
        }
      })
      // }
      // console.log("purchaseObj:::",purchaseObj);
      // this.router.navigate(['payment-success'])
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled self.');
      // // alert("sssss");
      // // let paymentFailedStatus=true;
      // let paymentFailedMsg = `Don't worry, transaction failed. If you are amount debited, please connect with administrator with your order Id:<strong> ${this.orderId}</strong>`;
      // // console.log("===STS==",this.paymentFailedStatus,this.paymentFailedMsg)
      // this.paymentService.setPaymentFailed({paymentFailedStatus:true, paymentFailedMsg:paymentFailedMsg});
      this.zone.run(() => {
        console.log('Transaction cancelled self.');
        this.paymentFailedStatus = true
        this.paymentFailedMsg = `OOOOPS!!! Your transaction failed. If your amount is debited from your account, please connect with  Customer Support with your order Id: <strong>${this.orderId}</strong>`;

        // this.paymentService.setPaymentFailed({ paymentFailedStatus: true, paymentFailedMsg: paymentFailedMsg });
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  initiateMatriOrder() {
    this.paymentFailedStatus = false;
    // this.getCompanyDetailsByVendorId()

    // this.paymentService.setPaymentFailed({paymentFailedStatus:false, paymentFailedMsg:""});
    // @joshi
    if (!this.isLoggedIn) {
      this.openLoginDialog();
      return;
    }


    let reqObj = {
      "amount": parseFloat(this.rowDetails.total_payble),
      "currency": "INR",
      "vendor_id": this.vendorData.id,
      "plan_id": this.rowDetails.id,
      "buyer_type": "VDR",
      "module_name": this.rowDetails.module_name
    }

    this.vendorService.initiateMatriOrder(reqObj).pipe(
      takeUntil(this.unsubscribe$)  // The request will terminate if unsubscribe$ emits a value
    ).subscribe((resp: any) => {
      console.log("Rec payment", resp);

      if (resp.statusCode == 200) {
        // this.paymentService.setrazorPaySubject(resp.data)
        this.payWithRazorMatriPurchases(resp.data.order_id, "rzp_live_mX3w8t1Xhx5fa1");
        this.orderId = resp.data.order_id;
        console.log("mmmmmm ", resp.data.order_id);
      }
    });
  }

  payWithRazorMatriPurchases(val: any, key: any) {

    let amount = (parseInt(this.rowDetails.plan_price) * 100);
    const options: any = {
      key: key,
      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: this.rowDetails.packageName, // company name or product name
      description: this.rowDetails.plan_description,  // product description
      image: 'assets/images/logos/final-logo.png', // company logo or product image
      order_id: val, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#BF0000'
      }
    };
    options.handler = ((response: any, error: any) => {
      options.response = response;

      console.log("response RAZORPAY::", response);
      console.log("RAZORPAY OPTIONS::", options);
      // pur_emp_type: CM/CN
      //pur_pac_type :JP/DB
      // packageData={packageName:"",amount:'',jobs:'',validity:'',description:''}
      // createPurchageOrder(){
      let purchaseObj = {
        plan_id: this.rowDetails.id,
        vendor_id: this.vendorData.id,
        razorpay_order_id: response.razorpay_order_id
      }

      this.paymentService.paymentDetails = { order_id: response.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id }
      this.vendorService.createPurchageOrderMatri(purchaseObj).subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          //           // this.errorStatus =true;
          //           // this.errorMsg = resp.supportMessage;
          //           // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"close","center","top",3);
          this.router.navigate(["pages/payment-success"])
        }
      })
      // }
      // console.log("purchaseObj:::",purchaseObj);
      // this.router.navigate(['payment-success'])
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled self.');
      // // alert("sssss");
      // // let paymentFailedStatus=true;
      // let paymentFailedMsg = `Don't worry, transaction failed. If you are amount debited, please connect with administrator with your order Id:<strong> ${this.orderId}</strong>`;
      // // console.log("===STS==",this.paymentFailedStatus,this.paymentFailedMsg)
      // this.paymentService.setPaymentFailed({paymentFailedStatus:true, paymentFailedMsg:paymentFailedMsg});
      this.zone.run(() => {
        console.log('Transaction cancelled self.');
        this.paymentFailedStatus = true
        this.paymentFailedMsg = `OOOOPS!!! Your transaction failed. If your amount is debited from your account, please connect with  Customer Support with your order Id: <strong>${this.orderId}</strong>`;

        // this.paymentService.setPaymentFailed({ paymentFailedStatus: true, paymentFailedMsg: paymentFailedMsg });
      });
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }


  goTo(link: any) {
    this.router.navigate([link]);
  }

  freePusrchaseOrder() {
  let reqObj = { id: this.rowDetails.id };

  this.vendorService.freePusrchaseOrder(reqObj).subscribe((resp: any) => {
    if (resp.statusCode === 200) {
      this.invoiceSignalService.setInvoiceNo(resp.data.invoice_no);
      console.log('Invoice set before navigate:', resp.data.invoice_no);

      // 👉 This is REQUIRED
      setTimeout(() => {
        this.router.navigate(["/pages/payment-success"]);
      });
    }
  });
}


  /* freePusrchaseOrder() {

    let reqObj = {
      id: this.rowDetails.id
    }

    this.vendorService.freePusrchaseOrder(reqObj).subscribe((resp: any) => {
      console.log('Rec State Created success', resp);

      if (resp.statusCode == 200) {
        this.invoiceSignalService.invoiceNo.set(resp.data.invoice_no);
        this.router.navigate(["pages/payment-success"])

      }

    });


  } */
  payNow() {
    if (this.rowDetails.plan_type === 'F') {
      this.freePusrchaseOrder();
    }
    else {
      this.initiateOrder();
    }
  }
  // payNow(){
  //   if(this.rowDetails.module_name === 'JOBS'){
  //     this.initiateJobOrder();
  //   }
  //   else if(this.rowDetails.module_name === 'JOBS_DB'){
  //     this.initiateDbPlansOrder();
  //   }
  //   else if(this.rowDetails.module_name === 'ADVERTS'){
  //     this.initiateAdvertPlansOrder();
  //   }
  //   else if(this.rowDetails.module_name === 'MATRI_VENDOR'){
  //     this.initiateMatriOrder();
  //   }
  // }

  getDiscountLabel(rowDetails: any): string {
    if (!rowDetails) return '';

    if (rowDetails.discount_type === 'NA') {
        return `Discount`;
    } else if (rowDetails.discount_type === 'P' && rowDetails.offer_discount_percentage > 0) {
        return `Discount (${rowDetails.offer_discount_percentage}%)`;
    } else if (rowDetails.discount_type === 'F' && rowDetails.offer_discount_flat > 0) {
        const flatDiscount = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(rowDetails.offer_discount_flat);
        return `Discount Flat (${flatDiscount})`;
    } else if (rowDetails.discount_type === 'F') {
        return `Discount Flat`;
    }

    return `Discount`;
}

calculateGstTotal(obj:any) {
  const sgstValue = obj.sgst || 0;
  const cgstValue =obj.cgst|| 0;
  const igstValue = obj.igst || 0;
  const cessValue = obj.cess || 0;

  const gstTotal = sgstValue + cgstValue + igstValue + cessValue;
  // this.gstTotalLabel = gstTotal
  // this.form.patchValue({ gstTotal });
  console.log("gst:",gstTotal)
  return gstTotal
}


}